module.exports = __webpack_public_path__ + "img/btn_menu-close.35bd9211.png";